var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dynamic-layout" },
    [
      _vm._l(_vm.dynamicData, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "flex-column dynamic-item" },
          [
            _c("p", { staticClass: "item-title-text flex text-left" }, [
              _c("span", { staticClass: "icon" }),
              _c("span", { staticClass: "text" }, [
                _vm._v(" " + _vm._s(item.title)),
                _c(
                  "a",
                  {
                    staticStyle: {
                      color: "#999999",
                      "margin-left": "10px",
                      cursor: "auto",
                    },
                  },
                  [_vm._v(_vm._s(item.date))]
                ),
              ]),
            ]),
          ]
        )
      }),
      _c("p", { staticClass: "dynamic-more pointer" }, [_vm._v("查看更多")]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }